import React from 'react';
import DetailField from './DetailField';

function RightColumnSection({ state, handleChange }) {
  return (
    <div className="TextContainerRight">
      {state.shop_name && (
        <DetailField
          label="Shop Name"
          name="shop_name"
          value={state.shop_name}
        />
      )}

      {state.shop_location && (
        <DetailField
          label="Shop Location"
          name="shop_location"
          value={state.shop_location}
        />
      )}

      {state.city && (
        <DetailField
          label="City"
          name="city"
          value={state.city || "undefined"}
        />
      )}

      {state.state && (
        <DetailField
          label="State"
          name="state"
          value={state.state || "undefined"}
        />
      )}

      {state.pincode && (
        <DetailField
          label="Pincode"
          name="mobile_number"
          value={state.pincode || "undefined"}
        />
      )}

      {state.district && (
        <DetailField
          label="District"
          name="district"
          value={state.district || "undefined"}
        />
      )}

      {state.agency_code && (
        <DetailField
          label="MSR Id"
          name="agency_code"
          value={state.agency_code}
        />
      )}

      {state.aps_code && (
        <div>
          <div className="Label_name_details">
            <label>APS Code</label>
            <input
              readOnly
              type="text"
              name="aps_code"
              value={state.aps_code}
              className="input_field_pgmdetails"
              onChange={handleChange}
            />
          </div>
        </div>
      )}

      {state.aps_name && (
        <div>
          <div className="Label_name_details">
            <label>APS Name</label>
            <input
              readOnly
              type="text"
              name="aps_name"
              value={state.aps_name}
              className="input_field_pgmdetails"
              onChange={handleChange}
            />
          </div>
        </div>
      )}

      <div>
        <div className="Label_name_details">
          <label>Area Head</label>
          <input
            readOnly
            type="text"
            name="area_head_email"
            value={state.area_head_email}
            className="input_field_pgmdetails"
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
}

export default RightColumnSection;
